import { PY_API } from "src/config-global";

// export const BACKEND_URL = 'http://localhost:5000';
export const BACKEND_URL = process.env.REACT_APP_HIRE_HOST_API;

export const urlMap = {
  // user
  login: `${BACKEND_URL}/api/v1/user/auth/login`,
  gettingStarted: `${BACKEND_URL}/api/v1/user/auth/started`,
  adminDetails: `${BACKEND_URL}/api/v1/user/details`,
  getUserDetails: `${BACKEND_URL}/api/v1/user`,
  forgotPassword: `${BACKEND_URL}/api/v1/user/auth/forgot`,
  updateUserDetails: `${BACKEND_URL}/api/v1/user/auth/update`,
  updatePassword: `${BACKEND_URL}/api/v1/user/update/password`,
  checkSignupStatus: `${BACKEND_URL}/api/v1/user/auth/signup/invite_status`,
  signup: `${BACKEND_URL}/api/v1/user/auth/signup/create`,

  // orgs
  publicOrgDetails: `${BACKEND_URL}/api/v1/public/org-details/{org-id}`,
  checkOrgHandleAvailable: `${BACKEND_URL}/api/v1/organization/handle/available/check`,
  createOrganization: `${BACKEND_URL}/api/v1/organization/create`,
  getCreditDetails: `${BACKEND_URL}/api/v1/credit/{org-id}/details`,
  orgUpdate: `${BACKEND_URL}/api/v1/organization/{org-id}/update`,
  getOrganizationDetails: `${BACKEND_URL}/api/v1/organization/{org-id}/details`,
  getOrganizationEmailTemplates: `${BACKEND_URL}/api/v1/organization/{org-id}/email_templates`,
  updateOrganizationEmailTemplates: `${BACKEND_URL}/api/v1/organization/{org-id}/update_email_template`,
  resetTemplate: `${BACKEND_URL}/api/v1/organization/{org-id}/reset_email_template`,
  getUsers: `${BACKEND_URL}/api/v1/admin/client/{org-id}/user-list`,
  inviteUser: `${BACKEND_URL}/api/v1/admin/client/{org-id}/team-invite`,
  checkInviteUser: `${BACKEND_URL}/api/v1/admin/client/{org-id}/check-invite/{user-id}`,
  confirmInviteUser: `${BACKEND_URL}/api/v1/admin/client/{org-id}/confirm-invite/{user-id}`,
  resendTeamInvite: `${BACKEND_URL}/api/v1/admin/client/{org-id}/resend-team-invite/{user-id}`,
  deactivateUser: `${BACKEND_URL}/api/v1/admin/client/{org-id}/deactivate-user/{user-id}`,
  activateUser: `${BACKEND_URL}/api/v1/admin/client/{org-id}/activate-user/{user-id}`,
  makeAdmin: `${BACKEND_URL}/api/v1/admin/client/{org-id}/make-admin/{user-id}`,

  // lead
  sendPricingRequest: `${BACKEND_URL}/api/v1/lead/price_request?plan={plan}`,

  // job
  getJobDetails: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}`,
  getJobOpenings: `${BACKEND_URL}/api/v1/{org-id}/job-opening/list`,
  createRole: `${BACKEND_URL}/api/v1/{org-id}/job-opening`,
  editRole: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/edit`,
  jobSuggestion: `${BACKEND_URL}/api/v1/{org-id}/jobs`,
  skillSuggestion: `${BACKEND_URL}/api/v1/{org-id}/jobs/skills`,
  getJobDescription: `${BACKEND_URL}/api/v1/{org-id}/jobs/job_description`,
  getJobDescTextFromDoc: `${BACKEND_URL}/api/v1/utility/document-to-text`,
  getPublicApplyLink: `${BACKEND_URL}/api/v1/shortlink/job/{job-id}/create`,
  getPublicLinkDetails: `${BACKEND_URL}/api/v1/shortlink/{link-id}/details`,
  getPublicJobDetails: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/public`,
  createInterviewLinkPublic: `${BACKEND_URL}/api/v1/{job-id}/interview/public`,
  publishUnpublishLink: `${BACKEND_URL}/api/v1/shortlink/job/{job-id}/{publish-query}`,
  createPrescreeningQues: `${BACKEND_URL}/api/v1/{org-id}/{job-id}/packet/prescreen`,
  getPrescreeningQues: `${BACKEND_URL}/api/v1/prescreen/{job-id}/start`,
  getPrescreeningResponse: `${BACKEND_URL}/api/v1/prescreen/{job-id}/submit`,
  getJobDescriptionFromLink: `${BACKEND_URL}/api/v1/{org-id}/jobs/job_page`,
  archiveJob: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/archive`,
  sendBulkJobInvite: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/bulk_job_invite`,
  pinJob: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/pin`,
  unpinJob: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-id}/unpin`,
  getPinnedJobs: `${BACKEND_URL}/api/v1/{org-id}/job-opening/pinned`,

  // tags
  getTags: `${BACKEND_URL}/api/v1/organization/{org-id}/candidate_tags`,
  addTag: `${BACKEND_URL}/api/v1/organization/{org-id}/candidate_tag/add`,

  // notes
  addNote: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{user-id}/note`,
  deleteNote: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{candidate-note-id}/delete`,

  // candidates
  getCandidates: `${BACKEND_URL}/api/v1/candidates/{org-id}/list?limit={limit}&page_number={page_number}`,
  getCandidatesByJobId: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidates?limit={limit}&page_number={page_number}`,
  getCandidateDetails: `${BACKEND_URL}/api/v1/candidates/{org-id}/{candidate-id}`,
  getCandidateDetailsByJobId: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{candidate-id}`,
  getFilteredCandidateListByJobId: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidates/filter?limit={limit}&page_number={page_number}`,
  addCandidate: `${BACKEND_URL}/api/v1/candidates/{org-id}/create`,
  editCandidateDetails: `${BACKEND_URL}/api/v1/candidates/{org-id}/{candidate-id}/edit`,
  getPreScreeningQuestions: `${BACKEND_URL}/api/v1/prescreen/{job-opening-id}/user/{user-id}/result`,
  shorlistCandidate: `${BACKEND_URL}/api/v1/{job-opening-id}/interview/shortlist`,
  getInpersonInterviewDetails: `${BACKEND_URL}/api/v1/inperson_interview/{job-opening-id}/{user-id}`,
  createInpersonInterview: `${BACKEND_URL}/api/v1/inperson_interview/{job-opening-id}/{user-id}/create`,
  updateInpersonInterview: `${BACKEND_URL}/api/v1/inperson_interview/{job-opening-id}/{user-id}/update`,
  rejectCandidate: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{user-id}/reject`,
  getCandidatesSummary: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidates_summary?candidate_group={candidate_group}`,
  hireCandidate: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{user-id}/hire`,
  bulkCandidateAction: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/bulk_action`,
  bulkCandidateEmail: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/bulk_email`,
  getCandidatesFilterSummary: `${BACKEND_URL}/api/v1/candidates/{org-id}/filter_summary`,
  getFilteredCandidates: `${BACKEND_URL}/api/v1/candidates/{org-id}/filter?limit={limit}&page_number={page_number}`,
  getPublicSharingLink: `${BACKEND_URL}/api/v1/shortlink/{job-opening-id}/{user-id}/create-public-link`,
  getCandidateDetailsById: `${BACKEND_URL}/api/v1/public/job-candidate/{candidate-id}`,
  getCandidateSources: `${BACKEND_URL}/api/v1/organization/{org-id}/candidate_sources`,
  addCandidateSource: `${BACKEND_URL}/api/v1/organization/{org-id}/candidate_source/add`,
  updateCandidateFlag: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/candidate/{user-id}/flag`,
  getReferralEligibleJobs: `${BACKEND_URL}/api/v1/{org-id}/job-opening/candidate/{user-id}/referral_eligible_jobs`,
  referCandidateToJob: `${BACKEND_URL}/api/v1/{org-id}/job-opening/{job-opening-id}/add_candidate`,

  // interview
  getInterviews: `${BACKEND_URL}/api/v1/{job-opening-id}/interview`,
  createInterview: `${BACKEND_URL}/api/v1/{job-opening-id}/interview`,
  bulkUpload: `${BACKEND_URL}/api/v1/utility/{job-opening-id}/bulk-upload`,

  createPacket: `${BACKEND_URL}/api/v1/{org-id}/{job-opening-id}/packet`,
  editPacket: `${BACKEND_URL}/api/v1/{org-id}/{job-opening-id}/packet`,
  getPacket: `${BACKEND_URL}/api/v1/{org-id}/{job-opening-id}/packet`,
  regenerateInterviewUrl: `${BACKEND_URL}/api/v1/{job-opening-id}/interview/{interview-id}/reset`,

  editInterviewQuestion: `${BACKEND_URL}/api/v1/{org-id}/{job-opening-id}/packet`,
  sendEmailInterview: `${BACKEND_URL}/api/v1/{job-opening-id}/interview/email`,
  evaluateSolution: `${BACKEND_URL}/api/v1/interview/{interview-id}/{question-id}/submit`,
  getInterviewDetails: `${BACKEND_URL}/api/v1/interview/{interview-id}/details`,

  // interview client
  evaluate: `${BACKEND_URL}/api/v1/interviewclient/transcribe`,
  result: `${BACKEND_URL}/api/v1/interviewclient/result`,
  putScreenRecord: `${BACKEND_URL}/api/v1/interview/{interview-id}/{question-id}/screenrecording`,
  startInterview: `${BACKEND_URL}/api/v1/interview/{interview-id}/start?token={token-id}`,
  endInterview: `${BACKEND_URL}/api/v1/interview/{interview-id}/end`,
  getInterviewResult: `${BACKEND_URL}/api/v1/{job-opening-id}/interview/{interview-id}`,
  editInterviewDetails: `${BACKEND_URL}/api/v1/{job-opening-id}/interview/{interview-id}`,

  // report
  generateReport: `${BACKEND_URL}/api/v1/report/{org-id}/create`,
  getReports: `${BACKEND_URL}/api/v1/report/{org-id}/list`,

  // notification
  getNotificationSettings: `${BACKEND_URL}/api/v1/organization/{org-id}/notification_settings`,
  updateNotificationSettings: `${BACKEND_URL}/api/v1/organization/{org-id}/notification_settings/update`,

  // coding interview
  generateCodingQuestion: `${BACKEND_URL}/api/v1/coding/{org-id}/{job-opening-id}/question/generate`,
  createCodingPacket: `${BACKEND_URL}/api/v1/coding/{org-id}/{job-opening-id}/coding-packet`,
  getCodingPackets: `${BACKEND_URL}/api/v1/coding/{org-id}/{job-opening-id}/coding-packets`,
  updateCodingPacket: `${BACKEND_URL}/api/v1/coding/{org-id}/coding-packet/{packet-id}`,
  createCodingInterview: `${BACKEND_URL}/api/v1/coding/{org-id}/{job-opening-id}/coding-interview`,
  sendCodingInterviewEmail: `${BACKEND_URL}/api/v1/coding/coding-interview/invite/{coding-interview-id}`,
  getCodingInterviewResult: `${BACKEND_URL}/api/v1/coding/coding-interview/details/{coding-interview-id}`,

  // two way interview
  enableTwoWayInterview: `${BACKEND_URL}/api/v1/two-way-interview/{org-id}/{job-opening-id}/enable`,
  createTwoWayInterview: `${BACKEND_URL}/api/v1/two-way-interview/{org-id}/{job-opening-id}/{user-id}/create`,
  getTwoWayInterviewResult: `${PY_API}/services/two-way-interview/{interview-id}/result`,

  // utility
  generateClientPresignedUrl: `${BACKEND_URL}/api/v1/utility/client/upload-presigned-url`,

};
